import { useState } from "react";
import Sidebar from "./Sidebar";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [newPass, setNewPass] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = await fetch("https://drpatangecitydentalclinic.com/api/changepassword.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        current: current,
        new: newPass,
      }),
    });

    const data = await res.json();
    setMessage(data.message);

    if (data.status === "success") {
      setCurrent("");
      setNewPass("");
    }
  };

  return (
    <div className="container-fluid p-4">
       <div className="row">

        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

                <div className="col-md-9 col-sm-12 col-lg-10 p-4">

<div className="container-fluid p-4">

  <h2 className="mb-4">Change Password</h2>

  <div className="row">
    <div className="col-12">

      <div className="card p-4 shadow w-100">

        <form onSubmit={handleSubmit}>

          <input
            type="password"
            className="form-control mb-3"
            placeholder="Current Password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            required
          />

          <input
            type="password"
            className="form-control mb-3"
            placeholder="New Password"
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
            required
          />

          <button className="btn btn-primary w-100">
            Update Password
          </button>

        </form>

        {message && (
          <div className="alert alert-info mt-3">
            {message}
          </div>
        )}

      </div>

    </div>
  </div>

</div>
      </div>
      </div>

    </div>
  );
}